export enum MouseMode {
    // drag to zoom on the x-axis only
    ZOOM_X = 'zoom-x',
    // drag to zoom on both x- and y-axes
    ZOOM_XY = 'zoom-xy',
    // click to draw a vertical line at a specific x-value
    DRAW_LINE_X = 'draw-line-x',
    // click to draw a horizontal line at a specific y-value
    DRAW_LINE_Y = 'draw-line-y',
    // click and drag to draw a line segment
    DRAW_LINE_SEGMENT = 'draw-line-segment',
    // drag and drag to draw a highlighted area across a range of x-values
    DRAW_AREA_X = 'draw-area-x',
    // click on an annotation to select it
    SELECT_ANNOTATIONS = 'select-annotations',
    // add or edit a text bubble on the plot
    ADD_TEXT_BUBBLE = 'add-text-bubble',
    // no mouse behavior
    NONE = 'none'
}
